import { UpsellResponse } from '@shared/flight-itinerary/entities/upsell-flights';
import { UpsellPayload } from '@upsell/entities/upsell-payload';

export const upsellFeatureName = 'upsellModuleState';

export type UiUpsellState = Readonly<{
  isLoadingUpsell: boolean;
  isLoadingUpsellForDesktop: boolean;
}>;

export type UpsellModuleState = Readonly<{
  upsell: UpsellResponse;
  upsellForDesktop: UpsellResponse;
  upsellPayload: UpsellPayload;
  clickedUpsell: number;
  ui: UiUpsellState;
}>;
